<template>
  <div class="-mb-4">
    <div class="flex items-baseline mb-4">
      <template v-if="gaCampaign">
        <header>
          <h5 class="text-xs text-gray-600 font-normal uppercase">Google Campaign</h5>
          <h3 class="text-base">
            {{ gaCampaign.name }}
          </h3>
        </header>
        <span
          :class="{
            'inline-block': true,
            'bg-green-200': gaCampaign.status_name === 'ENABLED',
            'bg-gray-200': gaCampaign.status_name !== 'ENABLED',
            'px-3': true,
            'py-1': true,
            'leading-snug': true,
            rounded: true,
            'text-xs': true,
            'text-green-900': gaCampaign.status_name === 'ENABLED',
            'text-gray-900': gaCampaign.status_name !== 'ENABLED',
            capitalize: true,
            'font-medium': true,
            'select-none': true,
            'ml-auto': true,
          }"
        >
          {{ gaCampaign.status_name }}
        </span>
      </template>
      <h3 v-else class="text-base mr-auto">Δεν υπάρχει συνδεδεμένη καμπάνια Google Ads</h3>

      <slot />
    </div>

    <template v-if="gaCampaign">
      <div
        v-if="gaCampaign.daily_reports.length"
        class="list list-spaced rounded-t-none border-0 -mx-4"
      >
        <GoogleAdsCampaignInsight
          period="Lifetime"
          :impressions="aggregatedReport.impressions"
          :reach="aggregatedReport.interactions"
          :frequency="0"
          :inline-link-clicks="aggregatedReport.clicks"
          class="text-lg"
        />

        <GoogleAdsCampaignInsightHeader />

        <template v-if="shouldDisplayMore">
          <GoogleAdsCampaignInsight
            v-for="(dailyReport, idx) in gaCampaign.daily_reports"
            :key="idx"
            :period="dailyReport.date_since"
            :impressions="dailyReport.impressions"
            :reach="dailyReport.interactions"
            :frequency="0"
            :inline-link-clicks="dailyReport.clicks"
          />
        </template>

        <a
          v-if="gaCampaign.daily_reports.length"
          role="button"
          class="px-4 block hover:bg-gray-100 focus:outline-none text-center"
          @click="toggleMore"
        >
          Show {{ shouldDisplayMore ? 'less' : 'more' }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { sumBy } from 'lodash-es';
import GoogleAdsCampaignInsightHeader from './GoogleAdsCampaignInsightHeader.vue';
import GoogleAdsCampaignInsight from './GoogleAdsCampaignInsight.vue';

export default {
  components: {
    GoogleAdsCampaignInsightHeader,
    GoogleAdsCampaignInsight,
  },

  props: {
    gaCampaign: { type: Object, required: true },
  },

  data: () => ({
    shouldDisplayMore: false,
  }),

  computed: {
    reports() {
      return this.gaCampaign?.daily_reports || [];
    },
    aggregatedReport() {
      return {
        impressions: sumBy(this.reports, 'impressions'),
        interactions: sumBy(this.reports, 'interactions'),
        frequency: 0,
        clicks: sumBy(this.reports, 'clicks'),
      };
    },
  },

  methods: {
    toggleMore() {
      this.shouldDisplayMore = !this.shouldDisplayMore;
    },
  },
};
</script>
